import { useEmployeeSearch } from '../hooks/useEmployeeSearch';
import { useTranslation } from 'react-i18next';
import type { EmployeeOption } from '../types/employee';
import SearchPicker from './SearchPicker';

interface Props {
  companyId?: string;
  includeInactive?: boolean;
  value: string | number;
  valueKey?: 'name' | 'id';
  onChange: (employee: EmployeeOption | null) => void;
  placeholder: string;
  disabled?: boolean;
  required?: boolean;
  size?: 'sm' | 'lg';
  showEmployeeId?: boolean;
}

export default function EmployeeSearchPicker({ companyId, includeInactive, value, valueKey = 'id', onChange,
  placeholder, disabled, required, size, showEmployeeId = true }: Props) {
  const { t } = useTranslation('common');
  const search = useEmployeeSearch(companyId, includeInactive);
  return <SearchPicker key={companyId} options={search.options} value={value} getValue={employee => employee[valueKey]}
    getLabel={employee => `${showEmployeeId ? `${employee.name} (${employee.emp_id})` : employee.name}${
      includeInactive && employee.is_active_today === false ? ` (${t('labels.inactive')})` : ''
    }`}
    onChange={onChange} onSearch={search.setSearch} placeholder={placeholder} loading={search.loading}
    error={search.error} onRetry={search.retry} disabled={disabled} required={required} size={size} />;
}
